






























import { defineComponent, onMounted, ref, useContext, onUnmounted } from '@nuxtjs/composition-api'

import { RelatedProduct } from './RelatedProducts.vue'
import { useCloudflareStore } from '~/store'
import RelatedCarouselCardSkeleton from '~/components/global/skeletons/RelatedCarouselCardSkeleton.vue'
import usePDPAnalytics from '@/composables/analytics/usePDPAnalytics'
import { MappedProduct } from '~/types/product/productTypes'
import { buildRelatedProduct } from '~/composables/product/useBuildRelatedProduct'

export default defineComponent({
  components: { RelatedCarouselCardSkeleton },
  props: {
    cardData: {
      type: Object as () => MappedProduct,
      required: true,
    },
  },
  emits: ['cardImageHover', 'cardImageLeave', 'openModal'],
  setup(props) {
    const { trackProductClick } = usePDPAnalytics()
    const cloudflareStore = useCloudflareStore()
    const isLoading = ref(false)
    const { $config } = useContext()
    const productData = ref({} as RelatedProduct)
    let debounceTimeout: ReturnType<typeof setTimeout> | null = null

    onMounted(() => {
      isLoading.value = true
      debounceTimeout = setTimeout(async () => {
        await cloudflareStore.fetchCloudflareProductImages(props.cardData.id)
        productData.value = buildRelatedProduct({ product: props.cardData, config: $config })
        isLoading.value = false
      }, 0)
    })

    onUnmounted(() => {
      if (debounceTimeout) {
        clearTimeout(debounceTimeout)
      }
    })

    return { isLoading, productData, trackProductClick }
  },
})
